import {
  buttonIcon,
  buttonPrimary,
  colors,
  fonts,
  mainHeight,
} from '../../theme';

// A post: the 9:16 player and its rail on the right, centered like the stage was.
const slide = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'stretch',
  gap: 2,
  // Same as SLIDE_DURATION (Feed.tsx).
  transition: 'transform 300ms ease-out',
};

const styles = {
  root: {
    position: 'relative',
    height: mainHeight,
    minHeight: 480,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  // "Pour toi" on the left, the filters on the right.
  header: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    minWidth: 0,
  },
  // Videos of a profile: a way back and the name of the player instead of the tabs and the filters.
  profileHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  back: buttonIcon,
  profileTitle: {
    fontFamily: fonts.text,
    fontSize: 18,
    fontWeight: 700,
    color: colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  stage: {
    position: 'relative',
    flexGrow: 1,
    minHeight: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 2,
    // Room under the player: it doesn't touch the bottom of the page.
    pt: 1,
    pb: 3,
  },
  // The comments open on the right: the player moves to make room for them.
  stageWithComments: {
    justifyContent: 'flex-end',
    pr: 8,
  },
  // Window of the posts (previous, current, next) stacked vertically: only the current one is seen.
  viewport: {
    position: 'relative',
    flexGrow: 1,
    minWidth: 0,
    height: '100%',
    overflow: 'hidden',
    // The z-index of the slides stays inside.
    isolation: 'isolate',
  },
  // The comments open on the right: the post goes next to them.
  slideWithComments: {
    justifyContent: 'flex-end',
  },
  slideCurrent: {
    ...slide,
    zIndex: 1,
    transform: 'translateY(0)',
  },
  slidePrevious: {
    ...slide,
    transform: 'translateY(-100%)',
    pointerEvents: 'none',
  },
  slideNext: {
    ...slide,
    transform: 'translateY(100%)',
    pointerEvents: 'none',
  },
  empty: {
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  emptyText: {
    fontFamily: fonts.text,
    fontSize: 14,
    color: colors.textSecondary,
  },
  emptyButton: buttonPrimary,
  // Above the posts: the current slide (z-index 1) spans the whole width, under the arrows too.
  arrows: {
    position: 'absolute',
    zIndex: 2,
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  arrow: {
    width: 48,
    height: 48,
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.surface,
    color: colors.text,
    '&:hover': {
      backgroundColor: colors.surfaceRaised,
      borderColor: colors.borderFocus,
    },
    '&.Mui-disabled': {
      color: colors.textSubtle,
      opacity: 0.4,
    },
  },
};

export default styles;
